
'use client'
import Image from "next/image";
import DownloadButton from "./ui/DownloadButton";
import ApplyButton from "./ui/ApplyButton";
import { useFormModal } from "@/context/FormContext";
import Link from "next/link";

const HeroSection = ({ data, onDownload, onApply }) => {
    const { openVideo } = useFormModal();
    const hero = data.heroSection;

    return (
        <section className="relative w-full overflow-hidden text-white">
            <div className="absolute inset-0 bg-[#081E2D]">

                <div
                    className="absolute inset-0 bg-cover bg-center opacity-20"
                    style={{
                        backgroundImage: `url(${hero.bannerImg})`
                    }}
                />
            </div>

            <div className="max-w-(--max-page-width) mx-auto px-(--container-padding) ">
                <div className="relative w-full mx-auto  py-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                    <div>
                        <div className="text-sm text-gray-300 mb-4">
                            {hero.breadcrumb.map((item, i) => (
                                <span key={i}>
                                    {i < 2 ? (
                                        <Link href={item.url} className="hover:text-amber-400" >
                                            {item.name}
                                        </Link>
                                    ) : (
                                        <span>{item.name}</span>
                                    )}

                                    {i !== hero.breadcrumb.length - 1 && (
                                        <span className="mx-2 text-gray-400">›</span>
                                    )}
                                </span>
                            ))}
                        </div>

                        <h1 className="text-3xl lg:text-4xl font-bold leading-tight mb-4">
                            {hero.title}
                        </h1>

                        <div className="flex items-center gap-3 mb-6">

                            <span className="text-sm text-gray-300">
                                {hero.poweredBy.text}
                            </span>

                            {hero.poweredBy.logo && (
                                <div className="bg-white px-3 py-1 rounded-md">

                                    <Image
                                        src={hero.poweredBy.logo}
                                        alt="Powered By"
                                        width={110}
                                        height={35}
                                    />

                                </div>
                            )}

                        </div>

                        <p className="text-[#FFA201] font-semibold mb-3">
                            {hero.duration}
                        </p>

                        <p className="text-gray-300 text-sm max-w-xl mb-8">
                            {hero.description}
                        </p>

                        <div className="flex flex-wrap gap-10 mb-8">

                            {hero.stats.map((stat, i) => (
                                <div key={i} className="relative">

                                    <p className="text-[#FFA201] text-xl font-bold">
                                        {stat.value}
                                    </p>

                                    <p className="text-gray-300 text-sm">
                                        {stat.label}
                                    </p>

                                </div>
                            ))}

                        </div>

                        <div className="flex flex-wrap gap-4">

                            {/* <DownloadButton text={hero.buttons.download} onClick={onDownload} /> */}

                            <ApplyButton text={hero.buttons.enroll} onClick={onApply} />

                        </div>

                    </div>

                    <div className="relative">

                        <div className="relative rounded-xl overflow-hidden shadow-lg">

                            {hero.video.thumbnail && (

                                <div className="relative w-full h-75 md:h-115 max-h-120 rounded-xl overflow-hidden">
                                    <Image
                                        src={hero.video.thumbnail}
                                        alt="Programme Video"
                                        fill
                                        className="object-cover"
                                        sizes="(max-width: 768px) 100vw, 50vw"
                                    />
                                </div>
                            )}
                            {hero.video.url =="#" ? "":(
                                <div className="absolute bottom-6 right-6">

                                <button className="flex items-center gap-2  px-4 py-2 rounded-sm text-sm font-medium shadow-lg 
                                border border-white hover:bg-[#e89500]/60 transition"
                                    onClick={() =>
                                        openVideo(hero.video.url)
                                    }
                                >

                                    <span className="w-8 h-8 flex items-center justify-center bg-white text-[#FFA201] rounded-full text-sm ml-1">
                                        ▶
                                    </span>

                                    {hero.video.buttonText}

                                </button>

                            </div>)}


                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
};

export default HeroSection;